// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import iconFactory from 'syft-acp-atoms/Icons'

import './IconQuestion.css'

const IconQuestion = ({ tooltipID, testID }: { tooltipID: string; testID: string }) => {
  const IconFactory = iconFactory('question', 'Question')
  return (
    <a data-for={tooltipID} data-testid={testID} data-tip>
      <IconFactory fill="white" className="questionIcon" iconSize={18} />
    </a>
  )
}
export default IconQuestion
